import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams } from "react-router-dom";

import SettingsPage from '../partials/SettingsPage';
import LoadingSpinner from '../partials/LoadingSpinner';
import PageHeader from '../partials/PageHeader';
import { Button, Text, Panel, Input, Small, H2, H3, Search, Select, H4, FormControlLabel, Switch, ButtonGroup, Box } from '@bigcommerce/big-design';
import { ReceiptIcon, ChevronLeftIcon, ChevronRightIcon, RedoIcon } from '@bigcommerce/big-design-icons';

import { getIncompleteOrders } from '../../redux/actions/incompleteOrders';

import UnfulfilledOrderLine from './UnfulfilledOrderLine';

const Orders = ({ payload, incompleteOrders, searchIncompleteOrders }) => {
  const [orderPage, setOrderPage] = useState(1);
  const [searchSubmitted, setSearchSubmitted] = useState(false);
  const [reverseSorting, setReverseSorting] = useState(true);

  useEffect(() => {
    // TODO: clear any existing created unfulfilled order

    searchIncompleteOrders(payload, orderPage, reverseSorting);
  }, []);

  const refreshOrders = () => {
    searchIncompleteOrders(payload, orderPage, reverseSorting);
  }

  const setIncompleteOrdersPage = (page) => {
    setOrderPage(page);
    searchIncompleteOrders(payload, page, reverseSorting);
  }

  const switchSorting = () => {
    setOrderPage(1);
    searchIncompleteOrders(payload, 1, !reverseSorting);
    setReverseSorting(!reverseSorting);
  }


  const description = () => {
    return(
      <> 
        <Text>Orders with the "Awaiting Fulfillment" state should appear in this list.</Text>
        <Small>Have questions or need some help? Contact us at <a href="mailto:support@athousandapps.com">support@athousandapps.com</a></Small>
      </>
    )
  }

  return(
    <>
      <PageHeader stripeBackground='#39a0a0' helpLink="bigcommerce/store-order-search/" />
      <SettingsPage title="Unfulfilled Orders" description={description()}>
        <Panel>
          <H2>Unfulfilled Orders</H2>
          <div className="flex-container">
            <div className="flex-1">
              { incompleteOrders.isFetching &&
                <LoadingSpinner
                  statusText='Loading unfulfilled orders'
                />
              }

              { !incompleteOrders.isFetching && incompleteOrders.status === 'success' &&
                <>
                  <div className="flex-container">
                    <div className="flex-1">
                      <Button
                        onClick={() => refreshOrders()}
                        iconLeft={<RedoIcon />}
                      >
                        Refresh Orders
                      </Button>

                    </div>

                    <div className="flex-1 bottom-15">
                      <H4>Reverse Orders Sorting</H4>
                      <Switch checked={reverseSorting} onChange={switchSorting} />
                    </div>

                    <div className="flex-container flex-1 flex-end">
                      <Button
                        iconLeft={<ChevronLeftIcon />}
                        variant="secondary"
                        disabled={!incompleteOrders.ordersPagination.has_previous_page}
                        onClick={() => setIncompleteOrdersPage(orderPage - 1)}
                      >
                        Previous Page
                      </Button>

                      <Button
                        iconRight={<ChevronRightIcon />}
                        variant="secondary"
                        disabled={!incompleteOrders.ordersPagination.has_theoretical_next}
                        onClick={() => setIncompleteOrdersPage(orderPage + 1)}
                      >
                        Next Page
                      </Button>

                    </div>
                  </div>

                  <Panel>
                    { 
                      incompleteOrders.orders.map((order) =>
                        <UnfulfilledOrderLine
                          payload={payload}
                          order={order}
                        />
                      )
                    }
                    { incompleteOrders.orders.length === 0 && orderPage === 1 &&
                      <Box
                        backgroundColor="primary20"
                        border="box"
                        borderRadius="normal"
                        padding="medium"
                      >
                        <H4>No Unfulfilled Orders</H4>
                        <Text>
                          When you have orders in the "Awaiting Fulfillment" state, they will appear in a list here.
                        </Text>
                      </Box>
                    }
                    { incompleteOrders.orders.length === 0 && orderPage > 1 &&
                      <Box
                        backgroundColor="warning20"
                        border="box"
                        borderRadius="normal"
                        padding="medium"
                      >
                        <H4>No More Orders</H4>
                        <Text>
                          Click the "Previous Page" button to see unfulfilled orders.
                        </Text>
                      </Box>
                    }
                  </Panel>
                </>
              }
            </div>
          </div>
        </Panel>
      </SettingsPage>
    </>
  )

}

const mapStateToProps = state => ({
  incompleteOrders: state.incompleteOrders,
});

const mapDispatchToProps = (dispatch) => ({
  searchIncompleteOrders: (payload, orderPage, reverseSorting) => dispatch(getIncompleteOrders(payload, orderPage, reverseSorting))
});

export default connect(mapStateToProps, mapDispatchToProps)(Orders);
